'use client';
import { rem } from '@s7/styles';

const IDENT = 'Container';
const defaultProps = {
    size: 'md1',
    sizes: {
        md1: rem(1208),
        lg1: rem(1440)
    }
};

export { IDENT, defaultProps };
//# sourceMappingURL=Container.contract.js.map
